const encodeId = id => btoa(encodeURI(id))

export default encodeId
